import React from "react";
import { string } from "prop-types";

const LeftArrowButton = ({
  color = "#4785ff",
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.047 65.61" width="60" height="60">
    
	<g>
		<path fill="#FFFFFF" d="M32.806,61.367c-0.768,0-1.535-0.293-2.121-0.879L2.999,32.806L30.685,5.121
			c1.172-1.171,3.07-1.171,4.242,0c1.172,1.171,1.172,3.071,0,4.243L11.484,32.806l23.442,23.44c1.172,1.171,1.172,3.07,0,4.242
			C34.342,61.074,33.573,61.367,32.806,61.367z"/>
	</g>
</svg>
);

LeftArrowButton.propTypes = {
  color: string,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
};

export default LeftArrowButton;
